import { Box, Skeleton as MuiSkeleton, Stack } from '@mui/material';

import { containerSx } from '../../styles';

const CardSkeleton = ({ height }: { height: number }) => (
  <Box sx={{ flex: 1, minWidth: 0 }}>
    <MuiSkeleton variant="rounded" sx={{ width: '100%', height, mb: 2 }} />
    <MuiSkeleton variant="rounded" sx={{ width: '80%', height: 16, mb: 1 }} />
    <MuiSkeleton variant="rounded" sx={{ width: '40%', height: 12 }} />
  </Box>
);

export const InsightsCategorySkeleton = () => (
  <Box sx={containerSx}>
    <MuiSkeleton
      variant="circular"
      sx={{ display: { xs: 'block', md: 'none' }, width: 36, height: 36, mb: 2, mx: 5 }}
    />
    <MuiSkeleton
      variant="rounded"
      sx={{ display: { xs: 'none', md: 'block' }, width: 80, height: 32, borderRadius: '40px', mb: 1 }}
    />

    <Box sx={{ mb: 6, display: 'flex', flexDirection: 'column', alignItems: { xs: 'flex-start', md: 'center' } }}>
      <MuiSkeleton variant="rounded" sx={{ width: { xs: 200, md: 300 }, height: { xs: 30, md: 44 } }} />
    </Box>

    <Box sx={{ display: { xs: 'none', md: 'flex' }, flexWrap: 'wrap', columnGap: 3, rowGap: 4 }}>
      {Array.from({ length: 8 }).map((_, i) => (
        <Box key={i} sx={{ width: { md: 'calc(33.333% - 16px)', lg: 'calc(25% - 18px)' } }}>
          <CardSkeleton height={i % 3 === 1 ? 281 : 228} />
        </Box>
      ))}
    </Box>

    <Stack sx={{ display: { xs: 'flex', md: 'none' }, gap: 4, px: 5 }} direction="row">
      <Stack gap={4} sx={{ flex: 1, minWidth: 0 }}>
        {Array.from({ length: 3 }).map((_, i) => (
          <CardSkeleton key={i} height={i % 2 === 0 ? 200 : 140} />
        ))}
      </Stack>
      <Stack gap={4} sx={{ flex: 1, minWidth: 0 }}>
        {Array.from({ length: 3 }).map((_, i) => (
          <CardSkeleton key={i} height={i % 2 === 0 ? 140 : 200} />
        ))}
      </Stack>
    </Stack>
  </Box>
);
